import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import mapValues from 'lodash/mapValues';
import zipObject from 'lodash/zipObject';

const MANIFEST_FILE_NAME = 'rev-manifest.json';

export const loadBlueprint = async (fileLoader, options = {}) => {
    const { pathPrefix, manifestFileName = MANIFEST_FILE_NAME } = options;

    const getPath = fileName => {
        return pathPrefix ? `${pathPrefix}${fileName}` : fileName;
    };

    const manifest = await fileLoader(getPath(manifestFileName));
    let blueprint = {};

    forEach(manifest, (fileName, name) => (blueprint[name] = fileLoader(getPath(fileName))));
    blueprint = zipObject(Object.keys(blueprint), await Promise.all(Object.values(blueprint)));

    return blueprint;
};

export const addBlueprintDataRefs = (blueprint, resolvedProps) => {
    const _blueprint = cloneDeep(blueprint);

    forEach(_blueprint.pages, ({ components = [] }) => {
        _addComponentsDataRefs(components, resolvedProps);
    });

    return _blueprint;
};

const _addComponentsDataRefs = (components, resolvedProps) => {
    forEach(components, component => {
        const replace = resolvedProps[component.id];

        if (replace) {
            forEach(replace, propName => (component.options[propName] = { ref: propName }));
        }

        if (component.components) {
            _addComponentsDataRefs(component.components, resolvedProps);
        }
    });
};

export const resolveBlueprintDataRefs = (blueprint, data) => {
    const _blueprint = cloneDeep(blueprint);
    const resolvedProps = {};

    forEach(_blueprint.pages, ({ components = [] }) => {
        _resolveComponentsDataRefs(components, data, resolvedProps);
    });

    return { blueprint: _blueprint, resolvedProps };
};

const _resolveComponentsDataRefs = (components, data, resolvedProps) => {
    forEach(components, component => {
        component.options = mapValues(component.options, prop => {
            if (prop && prop.ref) {
                const resolvedComponentProps = resolvedProps[component.id];

                if (resolvedComponentProps) {
                    resolvedComponentProps.push(prop.ref);
                } else {
                    resolvedProps[component.id] = [prop.ref];
                }

                return data[prop.ref];
            }

            return prop;
        });

        if (component.components) {
            _resolveComponentsDataRefs(component.components, data, resolvedProps);
        }
    });
};
